import { InputNumber } from "antd";

const UiInputNumber = ({
    label,
    required = false,
    onChange,
    ...restProps
}) => {
    return <div>
        <div style={{ padding: "10px" }}>
            {label && (
                <label>
                    {label} {required && <span style={{ color: 'red' }}>*</span>}
                </label>
            )}
        </div>
        <div>
            <InputNumber
                onChange={onChange}
                type="number"
                onWheel={(number) => number?.target?.blur()}
                {...restProps}
            />
        </div>
    </div>
};
export default UiInputNumber